import { aggregateProductVariants, productVariantTotals, type ProductVariant, type ProductVariantAggregate } from "./productAnalysisModel";
const sizeCollator = new Intl.Collator("tr", { numeric: true });

export type SizeGapCell = ProductVariantAggregate & { color_code: string; size: string; state: "available" | "depleted" | "negative" | "unknown" };
const apparel = ["XXXS", "XXS", "XS", "S", "M", "L", "XL", "XXL", "2XL", "XXXL", "3XL", "4XL", "5XL", "6XL"];
const unknown = (value: string) => ["", "—", "-", "BİLGİ YOK", "BILGI YOK", "UNKNOWN"].includes(value.trim().toLocaleUpperCase("tr-TR"));

// Presentation of the existing detail response only. No date, stock, import,
// sales or sell-through formula is changed, and no missing variant is invented.
export function buildProductSizeGaps(variants: ProductVariant[], inventorySupported = true) {
  const colors = aggregateProductVariants(variants, "color");
  const sizes = [...new Set(variants.map(row => row.size))].sort((a, b) => {
    const ai = apparel.indexOf(a.toUpperCase()), bi = apparel.indexOf(b.toUpperCase());
    const group = (value: string, index: number) => unknown(value) ? 3 : /^\d/.test(value) ? 0 : index >= 0 ? 1 : 2;
    return group(a, ai) - group(b, bi) || (ai >= 0 && bi >= 0 ? ai - bi : sizeCollator.compare(a, b));
  });
  const cells: SizeGapCell[] = colors.flatMap(color => aggregateProductVariants(
    variants.filter(row => row.color_code === color.label), "size",
  ).map(size => ({
    ...size, color_code: color.label, size: size.label,
    state: !inventorySupported ? "unknown" : size.stock_units > 0 ? "available"
      : size.stock_units < 0 ? "negative"
      : !unknown(color.label) && !unknown(size.label) && (size.import_units > 0 || size.sales_units > 0) ? "depleted" : "unknown",
  })));
  return { colors, sizes, cells, totals: productVariantTotals(colors),
    depleted: cells.filter(cell => cell.state === "depleted").length,
    negative: cells.filter(cell => cell.state === "negative").length,
    sizeTotals: sizes.map(size => ({ size, stock: cells.filter(cell => cell.size === size).reduce((sum, cell) => sum + cell.stock_units, 0) })),
  };
}
